import { render, staticRenderFns } from "./agreements.page.vue?vue&type=template&id=27b9f6be&scoped=true"
import script from "./agreements.page.vue?vue&type=script&lang=js"
export * from "./agreements.page.vue?vue&type=script&lang=js"
import style0 from "./agreements.page.vue?vue&type=style&index=0&id=27b9f6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9f6be",
  null
  
)

export default component.exports